export default __webpack_public_path__ + "239542bf2a487b06bf4022d6f3a9622a.png";